// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e7d3020e","453":"361feff5","455":"c427bb03"}[chunkId] + ".chunk.js";
};